import type { DescriptionsProperties } from '../../../descriptions';
import type { ErrorReport } from '../../types';
import { CodeBlock } from '../code-block';

type P = {
  response: ErrorReport['response'];
};

export const useGetResponseItems = ({ response }: P) => {
  if (!response) {
    return [];
  }

  const items: DescriptionsProperties['items'] = [
    { children: `${response.status} ${response.statusText}`, key: 'status', label: 'Status' },
  ];

  if (response.data) {
    items.push({ children: <CodeBlock value={response.data} />, key: 'received-data', label: 'Received data' });
  }

  return items;
};
